import { useState, useEffect } from 'react';

/**
 * React hook for managing CSRF token
 * @returns {Object} CSRF token and loading state
 */
export default function useCsrf() {
  const [csrfToken, setCsrfToken] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Function to fetch a new CSRF token
    async function fetchCsrfToken() {
      try {
        setLoading(true);
        const response = await fetch('/api/csrf', {
          method: 'GET',
          credentials: 'same-origin',
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch CSRF token: ${response.status}`);
        }

        const data = await response.json();
        setCsrfToken(data.csrfToken);
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      } finally {
        setLoading(false);
      }
    }

    // Fetch token on component mount
    fetchCsrfToken();

    // Refresh token every 30 minutes
    const intervalId = setInterval(fetchCsrfToken, 30 * 60 * 1000);

    // Clean up on unmount
    return () => clearInterval(intervalId);
  }, []);

  return { csrfToken, loading };
}
